import { render } from "./RecursiveContent.vue?vue&type=template&id=4c67b5e8"
import script from "./RecursiveContent.vue?vue&type=script&lang=js"
export * from "./RecursiveContent.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__